module.exports = __webpack_public_path__ + "files/0127fb58ed708a3aae433722f4fd8ed5.png";